// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14IQ_","content":"styles_content__3Hq1g","tableWrap":"styles_tableWrap__11Rdm"};